import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';

/** Css */
import Styles from "./Card.module.scss";

/** Assets */
import StockUp from 'images/stock-up.png';
import StockDown from 'images/stock-down.png';

import { emptyImage } from "utils"

type CardProps = {
  name: string;
  total: string;
  link: string;
  price: string;
  productImg: string;
  percent: string;
  up: boolean;
  category?: string;
};
const Card: React.FC<CardProps> = ({
  name,
  total,
  price,
  productImg,
  percent,
  up,
  link,
  category
}) => {
  const [img, setImg] = React.useState(productImg)

  return (
    <Link to={link} className={Styles[`nmu-card`]}>
      <div>
        <p className={Styles["name"]}>{name}</p>
        <p className={Styles["price"]}>{price}</p>
        {total ? (
          <span className={`${Styles[`trend`]} ${Styles['up']}`}>
            <li className={Styles['green-dot']} /> {total} sold
          </span>
        ) : (
          <span className={`${Styles["trend"]} ${Styles[up ? 'up' : 'down']}`}>
            <KickImage src={up ? StockUp : StockDown} /> {percent}
          </span>
        )}
      </div>
      <div className={Styles['img-box']}>
        <KickImage src={img} alt={name} onError={() => setImg(emptyImage(category))} />
      </div>
    </Link>
  );
};

export default Card